<div class="logo" [ngClass]="textPosition">
  <span *ngIf="showTitle" class="logo__title">{{ text | translate }}</span>
  <img class="logo__icon" [alt]="alt" [src]="src" />
</div>
